import { parseISO } from "date-fns";
import * as styles from "components/layout/Search/Results/Results.module.scss";
import { Countdown } from "components/layout/Countdown";
import { Icon } from "library";
import { Link } from "components/Link";
import React from "react";

type RowsProps = {
  icon: React.ReactNode;
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  highlight?: React.ReactNode;
  to?: string;
  startTime?: string;
};

export const Row = ({
  icon,
  title,
  subTitle,
  highlight,
  to,
  startTime,
}: RowsProps) => {
  const parsedStartTime = startTime ? parseISO(startTime) : null;
  const shouldShowButtons = Boolean(to) || Boolean(startTime);

  const rowContents = (
    <>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
        {highlight && <div>{highlight}</div>}
      </div>
      {shouldShowButtons && (
        <div className={styles.cluster}>
          {parsedStartTime && (
            <Countdown
              clampClassName={styles.countdown}
              scheduledStartTime={parsedStartTime}
            />
          )}
          {to && (
            <div className={styles.link}>
              <Icon type="arrow-right" inline />
            </div>
          )}
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <Link className={styles.row} to={to}>
        {rowContents}
      </Link>
    );
  }

  return <div className={styles.row}>{rowContents}</div>;
};
